import { Button } from "@/components/ui/button";
import { RefreshCw, X } from "lucide-react";
import { clearCorruptedSession } from "@/lib/utils/auth-utils";
import { useState } from "react";

export function SessionRecovery() {
  const [dismissed, setDismissed] = useState(false);

  const handleRecovery = () => {
    clearCorruptedSession();
    window.location.reload();
  };

  if (dismissed) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 p-4 bg-card rounded-lg shadow-lg max-w-sm animate-in slide-in-from-bottom-2 duration-300">
      <button 
        onClick={() => setDismissed(true)}
        className="absolute top-2 right-2 text-on-dark-muted hover:text-on-dark transition-colors"
        aria-label="Dismiss"
      >
        <X className="h-4 w-4" />
      </button>
      <p className="text-sm text-on-dark mb-2 pr-6">
        Taking longer than expected?
      </p>
      <Button
        size="sm"
        onClick={handleRecovery}
        className="w-full"
      >
        <RefreshCw className="mr-2 h-4 w-4" />
        Refresh Session
      </Button>
      <p className="text-xs text-on-dark-muted mt-2">
        This will clear your local session data and reload the page.
      </p>
    </div>
  );
}